/* Retain normal category navigation while revealing the new assortment smoothly. */
(() => {
  if (window.geCollectionNavigationReady) return;
  window.geCollectionNavigationReady = true;
  const key = 'ge-category-scroll';
  const reducedMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const reveal = () => document.getElementById('assortiment')?.scrollIntoView({block: 'start', behavior: reducedMotion() ? 'instant' : 'smooth'});
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-ge-smooth-category]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
    const url = new URL(link.href);
    if (url.origin !== location.origin || url.hash !== '#assortiment') return;
    if (url.pathname === location.pathname && url.search === location.search) {
      event.preventDefault(); reveal(); return;
    }
    try { sessionStorage.setItem(key, JSON.stringify({path: url.pathname + url.search, at: Date.now()})); }
    catch { return; }
    event.preventDefault();
    url.hash = '';
    location.assign(url.href);
  });
  const restore = () => {
    let pending;
    try { pending = JSON.parse(sessionStorage.getItem(key)); sessionStorage.removeItem(key); }
    catch { return; }
    if (!pending || pending.path !== location.pathname + location.search || Date.now() - pending.at > 30000) return;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      history.replaceState(history.state, '', location.pathname + location.search + '#assortiment');
      reveal();
    }));
  };
  if (document.readyState === 'complete') restore();
  else window.addEventListener('load', restore, {once: true});
})();
